/**
 * Central configuration for email addresses used throughout the application
 */

export const emailConfig = {
  /**
   * The main support email address shown to users for help and inquiries
   */
  supportEmail: 'support@tapdonkey.com',
  
  /**
   * No-reply email address used for system notifications and transactional emails
   */
  noReplyEmail: 'noreply@tapdonkey.com',
  
  /**
   * Display format for the no-reply email with sender name
   */
  noReplyEmailFormatted: 'TapDonkey <noreply@tapdonkey.com>',
  
  /**
   * Email for info and general inquiries
   */
  infoEmail: 'info@tapdonkey.com',
  
};

export default emailConfig; 